import { type ReactNode } from 'react'

import { CheckBadge } from './check-badge'
import { type LabeledOption } from './enum-labels'
import { RemoveButton } from './remove-button'

export function SelectedCard({
  option,
  incomplete,
  onRemove,
  children
}: {
  option: LabeledOption
  incomplete: boolean
  onRemove: () => void
  children: ReactNode
}) {
  return (
    <li
      className={`flex items-start gap-3 rounded-xl border p-4 ${
        incomplete
          ? 'border-amber-400 bg-amber-50/40 dark:border-amber-600 dark:bg-amber-950/30'
          : 'border-accent bg-accent-light/30'
      }`}
    >
      <CheckBadge />
      <div className='min-w-0 flex-1'>
        <div className='flex items-center gap-2'>
          <p className='min-w-0 flex-1 text-[14px] font-medium text-ink'>
            {option.label}
          </p>
          <RemoveButton label={`Remove ${option.label}`} onClick={onRemove} />
        </div>
        <p className='mt-0.5 text-[12px] text-ink-soft'>{option.description}</p>
        <div className='mt-3 flex flex-wrap items-center gap-3'>{children}</div>
      </div>
    </li>
  )
}
